import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Accordion as BootstrapAccordion, Card } from 'react-bootstrap';
import { Icon } from '../KeyComponents';

const Accordion = React.forwardRef(
  (
    {
      children,
      defaultActiveKey,
      icon,
      title,
      alwaysOpen,
      className,
      dropDownArrow,
      ...props
    },
    ref
  ) => {
    const [active, setActive] = useState(defaultActiveKey);
    useEffect(() => {
      if (alwaysOpen) {
        setActive('0');
      }
    }, [alwaysOpen]);

    const handleClick = useCallback(() => {
      if (alwaysOpen) {
        setActive('0');
      } else {
        setActive(active === '0' ? '' : '0');
      }
    }, [alwaysOpen, active]);

    return (
      <BootstrapAccordion
        defaultActiveKey={defaultActiveKey}
        title={title}
        activeKey={alwaysOpen ? '0' : active}
        className={className}
        {...props}
      >
        <Card>
          <BootstrapAccordion.Toggle as={Card.Header} className={classNames({ active: active === '0' })} eventKey="0" onClick={handleClick}>
            <div className="accordion-header">
              {dropDownArrow === 'left' ? <Icon icon="arrow-down-s" type="line" size="sm" className={classNames('accordion-arrow', { rotate: active === '0' })} /> : icon && <Icon icon={icon} type="line" size="sm" className={classNames('accordion-icon')} />}

              <span className="accordion-title">{title}</span>
            </div>
            {dropDownArrow === 'right' && <Icon icon="arrow-down-s" type="line" size="sm" className={classNames('accordion-arrow', { rotate: active === '0' })} />}
          </BootstrapAccordion.Toggle>
          <BootstrapAccordion.Collapse eventKey="0" ref={ref} className={classNames({ show: active === '0' })}>
            <Card.Body className="text-muted">{children}</Card.Body>
          </BootstrapAccordion.Collapse>
        </Card>
      </BootstrapAccordion>
    );
  }
);

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  defaultActiveKey: PropTypes.string,
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  alwaysOpen: PropTypes.bool,
  className: PropTypes.string,
  activeKey: PropTypes.string,
  onToggle: PropTypes.func,
  dropDownArrow: PropTypes.oneOf(['left', 'right'])
};

Accordion.defaultProps = {
  defaultActiveKey: '',
  icon: null,
  alwaysOpen: false,
  className: '',
  activeKey: '',
  onToggle: null,
  dropDownArrow: 'right'
};

export default Accordion;
